const EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER = "experimentDetailAlerts";
const FEATURE_DETAILS_PAGE_ALERT_REDUCER = "featureDetailAlerts";
export {
  EXPERIMENT_DETAILS_PAGE_ALERT_REDUCER,
  FEATURE_DETAILS_PAGE_ALERT_REDUCER
};
//# sourceMappingURL=ReducerConstants.js.map
